var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled, css } from 'styled-components';
import { TableDay } from '../Common';
import { useWeeklyDashboardAnalytics, WeeklyDashboardEvents, } from '../../hooks/useWeeklyDashboardAnalytics';
var ScActivityDayContainer = styled(TableDay).withConfig({ displayName: "ScActivityDayContainer", componentId: "sc-1pgmvn9" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  font-style: normal;\n  letter-spacing: 0.6px;\n  white-space: pre-line;\n  text-align: center;\n  text-transform: none;\n  color: ", ";\n  background: ", ";\n\n  &[data-active='true'] {\n    background: ", ";\n  }\n\n  ", "\n"], ["\n  width: 24px;\n  height: 24px;\n\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  font-style: normal;\n  letter-spacing: 0.6px;\n  white-space: pre-line;\n  text-align: center;\n  text-transform: none;\n  color: ", ";\n  background: ", ";\n\n  &[data-active='true'] {\n    background: ", ";\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue95;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.purple80;
}, function (_a) {
    var $hasStatus = _a.$hasStatus;
    return $hasStatus && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: 13px;\n      letter-spacing: -0.2px;\n    "], ["\n      font-size: 13px;\n      letter-spacing: -0.2px;\n    "])));
});
var ActivityDayContainer = function (_a) {
    var isActive = _a.isActive, hasStatus = _a.hasStatus, focusable = _a.focusable, rest = __rest(_a, ["isActive", "hasStatus", "focusable"]);
    var sendEvent = useWeeklyDashboardAnalytics();
    return (_jsx(ScActivityDayContainer, __assign({ "data-active": isActive.toString(), "$hasStatus": hasStatus, tabIndex: focusable ? 0 : -1, onMouseEnter: function () {
            sendEvent(WeeklyDashboardEvents.studentDayHover);
        } }, rest), void 0));
};
export { ActivityDayContainer };
var templateObject_1, templateObject_2;
